import Header from './fragment-main/header.js';
import Navi from './fragment-main/navi.js';
import Footer from './fragment-main/footer.js';

const MainLayout = ({ children }) => (
	<div style={{
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
		overflow: 'visible'
	}}>
		<Header />
		<Navi />
		<main style={{ flex: '1 0 auto' }}>{children}</main>
		<Footer />
	</div>
);

export default MainLayout;